import { render, staticRenderFns } from "./SettingKepemilikan.vue?vue&type=template&id=6692d42e&scoped=true&"
import script from "./SettingKepemilikan.vue?vue&type=script&lang=js&"
export * from "./SettingKepemilikan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6692d42e",
  null
  
)

export default component.exports